/**
 * 便民服务新增
 */
import React from 'react';
import AddUser from "../userManage/AddUser";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";

export default class ConvenienceServeAdd extends AddUser {

    componentWillMount() {
    }

    componentDidMount() {

    }

    show(record) {
        if (record) {
            this.request({
                url: "/cm-sites-mmp/homepageUrl/getById",
                method: "get",
                body: {id: record.id},
                callBack: (res) => {
                    const addFields = this.getAddFields();
                    let addDataObj = {};
                    addDataObj.id = res.id;
                    addFields.forEach(item => {
                        if (res[item.field]) {
                            addDataObj[item.field] = res[item.field]
                        }
                    })
                    if (res) {
                        this.setState({
                            visible: true,
                            title: "编辑服务",
                            addDataObj
                        })
                    }
                }
            });
        } else {
            this.setState({
                visible: true,
                title: "新增服务",
                addDataObj: {
                    urlStatus: "1", //默认为启用
                }
            })
        }
    }

    checkForm = () => {
        const addFields = this.getAddFields();
        let urlReg = new RegExp("(http|https):\\/\\/([\\w.]+\\/?)\\S*");
        for (let i = 0; i < addFields.length; i++) {
            let item = addFields[i];
            if (item.isRequired && !this.state.addDataObj[item.field]) {
                message.info("请检查必填项！");
                return false;
            }
            if (item.field === "urlAddress" && !urlReg.test(this.state.addDataObj[item.field])) {
                message.info("服务地址必须以http，https开头，且需符合URL规范，检查格式是否正确！");
                return false;
            }
        }
        return true;
    }

    saveData() {
        //校验
        if (!this.checkForm()) return false;
        let params = {
            ...this.state.addDataObj
        };
        let url = "/cm-sites-mmp/homepageUrl/add";
        if (this.state.addDataObj.id) {
            params.id = this.state.addDataObj.id;
            url = "/cm-sites-mmp/homepageUrl/edit";
        }
        this.request({
            url,
            body: params,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    message.success("提交成功");
                    this.setState({
                        visible: false,
                    })
                    this.props.refreshList();
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    }

    /**
     * 新增字段
     * type 1  输入框
     * type 2  Select选择框
     * type 3  Cascader级联选择框
     * type 4  单选框
     */
    getAddFields() {
        return (
            [
                {
                    key: "urlName",
                    field: "urlName",
                    title: "服务名称",
                    type: "1",
                    isRequired: true,
                    maxLength: 8
                },
                {
                    key: "urlAddress",
                    field: "urlAddress",
                    title: "服务地址",
                    type: "1",
                    isRequired: true,
                },
                {
                    key: "urlStatus",
                    field: "urlStatus",
                    title: "状态",
                    type: "3",
                    isRequired: true,
                    options: [
                        {
                            key: "1",
                            value: "1",
                            title: "启用"
                        },
                        {
                            key: "2",
                            value: "2",
                            title: "禁用"
                        }
                    ]
                },
                {
                    key: "urlPic",
                    field: "urlPic",
                    title: "服务图片",
                    type: "5",
                    isRequired: true,
                },
            ]
        )
    }

}